import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  saveLoading: false,
  labsLength: 0,
  labs: [],
  labsError: "",
  formError: "",
};

export default function labsReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_LABS:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_LABS:
      return { ...state, saveLoading: action.payload };
    case actions.GET_LABS:
      return {
        ...state,
        labs: action.payload.labs,
        labsLength: action.payload.labsLength,
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.LABS_FAIL:
      return { ...state, labsError: action.payload };
    default:
      return state;
  }
}
